import { assertEvent, assign } from 'xstate5';

import {
  removeModificationToActiveModificationsList,
  resolveIngredientIdForRemove,
} from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Handles the removal of a modification from the list of active modifications
 * within the customization context.
 */
export const removeModification: CustomizationMachineAction = assign((args) => {
  const { context, event } = args;

  assertEvent(event, [
    'customization.remove-modification',
    'customization.dressing.decrease-portions',
  ]);

  const { allModificationsMap, modifications, extrasModificationsMap, modificationLimits } =
    context;

  if (!allModificationsMap || !modifications) {
    return {};
  }

  const { active } = modifications;

  const resolvedIngredientId = resolveIngredientIdForRemove({
    ingredientId: event.ingredientId,
    allModificationsMap,
    extrasModificationsMap,
    modificationLimits,
    activeModifications: active,
  });

  const updatedActives = removeModificationToActiveModificationsList({
    ingredientId: resolvedIngredientId,
    activeModifications: active,
    allModificationsMap,
  });

  return { modifications: { ...modifications, active: updatedActives } };
});
